export default __webpack_public_path__ + "fonts/home-4.svg";